import React from 'react';
import classnames from 'classnames';
import { withLocalize, Translate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { searchActions, defaultPaging, searchType, defaultOrderBy } from '../../store/searchStore';
import { isObjectPathDefined } from "../../store/apiWrapper";
import { domainActions } from '../../store/domainStore';
import { layoutActions } from '../../store/layoutStore';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { parseQuery } from '../../store/apiWrapper';
import { Circles } from '../common/loadingComponent';
import NoDataComponent from '../common/noDataComponent';
import ErrorComponent from '../common/errorComponent';
import MainSearchRow from './mainSearchRow';
import Paging from '../common/pagingComponent';
import ReactResizeDetector from 'react-resize-detector';

import '../../css/search/search.scss'

class SearchResults extends React.Component {
    state = {
        maxTableWidth:0
    };

    render() {
        return (
            <div style={{ display: "flex", flexGrow: '1', flexDirection: "column" }}>
                <div className="search-layout">
                    {this.props.isSearching && <Circles />}
                    {!this.props.isSearching && this.areAnyResults(this.props.searchResult) && this.renderWithResults()}
                    {!this.props.isSearching && !this.areAnyResults(this.props.searchResult) && this.renderNoResult(this.props.searchResult)}
                </div>
                {this.renderBottomPanel(this.props.searchResult)}
            </div>
        )
    }

    renderWithResults() {
        return (
            <>
                <div className="search-data">
                    {this.renderError(this.props.searchResult)}
                    {this.props.searchResult.data.subjects.length > 0 &&
                        <div className="sr-result-list">
                            {this.renderSubjectTable(this.props.searchResult.data.subjects)}
                        </div>
                    }
                </div>
            </>
        )
    }

    componentDidMount() {
        const qs = parseQuery(window.location.search);
        let params = this.parseParams(qs)
        this.props.getSubjects(qs.type || searchType.BS, params, { ...defaultPaging }, defaultOrderBy);
        this.props.setSearchParams(params);
        this.getRdcIfNeeded();
    }

    getRdcIfNeeded = () => {
        if (isObjectPathDefined(this.props, 'searchDomains') && !isNullOrUndefined(this.props.searchDomains.rdcIds)) {
            //if coming from /search, this data should be filled
            return;
        }
        else {
            this.props.ensureDomainData('region-district-city');
        }
    }

    componentDidUpdate(prevProps) {
        if (!isNullOrUndefined(prevProps.search) && prevProps.search !== "" && prevProps.search.indexOf("?hyperlinkSsoToken") === -1 && (prevProps.location + prevProps.search) !== (window.location.pathname + window.location.search)) {
            const qs = parseQuery(window.location.search);
            let params = this.parseParams(qs)
            this.props.getSubjects(qs.type || searchType.BS, params, { ...defaultPaging }, defaultOrderBy);
            this.props.setSearchParams(params);
            this.getRdcIfNeeded();
        }

        //wait for rdc to load then parse from query string and put to store
        if (!this.domainsLoading() && this.props.searchDomains === null) {
            const qs = parseQuery(window.location.search);
            if (!isNullOrUndefined(qs.rdcIds)) {
                let splitted = qs.rdcIds.split(",");
                let rdc = [];
                splitted.map(s => {
                    let found = this.props.domain['region-district-city'].requestResult.find(x => x.value === s);
                    rdc[found.value] = found.label;
                })
                this.props.setSearchDomain({ rdcIds: rdc });
            }
        }

        if (this.props.languageChanged)
            this.props.repeatSearch();
    }

    parseParams = (qs) => {
        let params = { country: 3, actualOnly: true };
        if (qs.q !== undefined && qs.q !== '') {

            let icoDicIcdph = /^(([0-9]{8}|[0-9]{10}|[a-z]{2}[0-9]{8,10})(\s|[,;]|OR)*)+$/gi;
            let icoDicIcdph2 = /^([0-9]{8}|[0-9]{10}|[a-z]{2}[0-9]{8,10})$/gi;
            let lei = /^[0-9]{4}[0]{2}[a-zA-Z0-9]{14}$/gi;
            if (icoDicIcdph.test(qs.q))
                params.icoDic = qs.q.split(/(?:\s|[,;]|OR)+/gi);
            else if (icoDicIcdph2.test(qs.q.replace(/\s/g, '')))
                params.icoDic = [qs.q.replace(/\s/g, '')];
            else if (lei.test(qs.q.replace(/\s/g, '')))
                params.icoDic = [qs.q];
            else
                params.name = qs.q;
        }
        if (isNullOrUndefined(qs.isPo) || qs.isPo === '')
            params.isPo = null;
        else
            params.isPo = qs.isPo === "true";
        if (!isNullOrUndefined(qs.street)) params.street = qs.street;
        if (!isNullOrUndefined(qs.bankAccount)) params.bankAccount = qs.bankAccount;
        if (!isNullOrUndefined(qs.dob)) params.dob = qs.dob;
        if (!isNullOrUndefined(qs.rdcIds)) params.rdcIds = qs.rdcIds.split(",");

        return params;
    }

    domainsLoading = () => {
        return this.props.domain['region-district-city'].isRequesting || this.props.domain['region-district-city'].requestResult == null;
    }

    renderBottomPanel = (sr) => {
        if (!this.areAnyResults(sr))
            return null;
        if (Math.ceil(sr.data.totalFound / this.props.searchPaging.count) < 2) {
            return null;
        }
        return (
            <div className='bottom-panel paging-wrapper' style={{ marginBottom: '1em'}}>
                <Paging selectedPage={this.props.searchPaging.page}
                    totalPages={Math.ceil(sr.data.totalFound / this.props.searchPaging.count)}
                    setPage={this.onPageClick} />
            </div>
        )
    }

    renderError = (sr) => {
        if (isNullOrUndefined(sr) || isNullOrUndefined(sr.data) || isNullOrUndefined(sr.data.error))
            return null;

        return (<>
            <ErrorComponent message={sr.data.error.reason} back={<>
                <br /><br />
                <Link to='/search'>
                    <button className={classnames('bb-button small gradient-1', {'is-square': localStorage.locales_button_style === 'square' })}>
                        {this.props.translate('Common.Back')}
                    </button>
                </Link>
            </>} />
        </>);
    }

    renderNoResult = (sr) => {
        if (!isNullOrUndefined(sr) && !isNullOrUndefined(sr.data) && !isNullOrUndefined(sr.data.error)  && !isNullOrUndefined(sr.data.error.reason))
            return this.renderError(sr);
        else if (isNullOrUndefined(sr) || isNullOrUndefined(sr.data) || !Array.isArray(sr.data.subjects) || sr.data.subjects.length < 1)
            return this.renderNoSubjectFound();
        else return null;
    }

    renderNoSubjectFound = () => {
        return (<>
            <NoDataComponent back={<>
                <br /><br />
                <Link to='/search'>
                    <button className={classnames('bb-button small gradient-1', {'is-square': localStorage.locales_button_style === 'square' })}>
                        {this.props.translate('Search.ModifyParameters')}
                    </button>
                </Link>
            </>} />
        </>);
    }

    renderSubjectTable = (subjects) => {
        return (<>
            <ReactResizeDetector handleWidth refreshMode='debounce' refreshRate={500} onResize={this.onResize} />
            <div className="table sr-table">
                <div className="sr-result" key={'probe-row'} style={{borderWidth:0}}>
                    <div ref={el => this.probeNumRow = el}></div>
                    <div>
                        <div ref={el => this.probeTrigger = el} style={{width:'1cm'}}></div>
                    </div>
                </div>
                {subjects.map((s, i) => {
                    return (
                        <div className="sr-result" key={s.entityId}>
                            <div className="sr-result-index">{i + 1 + this.props.searchPaging.offset}.</div>
                            <div><MainSearchRow s={s} maxTableWidth={this.state.maxTableWidth} /></div>
                        </div>
                    )
                })}
            </div>
        </>);
    }

    onResize = (width, height) => {
        const numberRow = (this.probeNumRow || {getBoundingClientRect:function(){return {}}}).getBoundingClientRect().width || 0;
        const triggerW = (this.probeTrigger || {getBoundingClientRect:function(){return {}}}).getBoundingClientRect().width || 0;
        this.setState({maxTableWidth: width - numberRow - triggerW});
    }

    areAnyResults = sr => {
        // Don't render if any error is present.
        if (!isNullOrUndefined(sr) && !isNullOrUndefined(sr.data) && !isNullOrUndefined(sr.data.error))
            return false;

        if (isNullOrUndefined(sr) || isNullOrUndefined(sr.data) || !Array.isArray(sr.data.subjects) || sr.data.subjects.length < 1)
            return false;

        return true;
    }

    onPageClick = (page) => {
        this.props.changePage(page);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}

export default withRouter(withLocalize(connect(
    state => ({ ...state.search, domain: state.domain }),
    dispatch => bindActionCreators(Object.assign({}, searchActions, domainActions, layoutActions), dispatch),
)(SearchResults)));